import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm hover:shadow-md transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={testimonial?.avatar}
            alt={testimonial?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
            {testimonial?.name}
          </h4>
          <p className="text-sm text-muted-foreground mb-1">{testimonial?.position}</p>
          <p className="text-xs text-muted-foreground">{testimonial?.company}</p>
        </div>
        <div className="flex-shrink-0">
          <Icon name="Quote" size={24} className="text-accent opacity-50" />
        </div>
      </div>
      <p className="text-sm md:text-base text-foreground mb-4 line-clamp-4">
        {testimonial?.content}
      </p>
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-1">
          {[...Array(5)]?.map((_, index) => (
            <Icon
              key={index}
              name="Star"
              size={16}
              className={index < testimonial?.rating ? 'text-accent fill-accent' : 'text-muted'}
            />
          ))}
        </div>
        <span className="text-xs text-muted-foreground">{testimonial?.date}</span>
      </div>
    </div>
  );
};

export default TestimonialCard;